/**
 * Converts cue text to HTML markup. Some subtitle cue text contains
 * `/n` and other characters. This converts those into the appropriate
 * HTML markup string.
 *
 * e.g. `Line One\nLine Two` becomes `Line One<br/>Line Two`
 * @param cueText The raw cue text to convert
 * @returns The converted HTML string
 */
export function cueTextToHtml(cueText: string): string {
  let renderText = cueText;

  // Convert newline `\n` to break tag
  renderText = cueText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

  return renderText;
}
